import { render, staticRenderFns } from "./SalariesView.vue?vue&type=template&id=1e591988&"
import script from "./SalariesView.vue?vue&type=script&lang=js&"
export * from "./SalariesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports